<template>
    <div>
        <h1 style="font-size: 24px; color: black;">热门问答专区素材</h1>
        <div style="margin-bottom: 10px;">
            <el-card class="form-container" style="margin-top: 25px">
                <el-row type="flex" align="middle">
                    <el-col :span="5">
                        <span> 标题：</span>
                        <el-input style="width: 300px" placeholder="模糊查询" v-model="query.title"></el-input>
                    </el-col>
                    <el-col :span="6">
                        <span> 标签：</span>
                        <div class="tree-select-wrapper">
                            <el-popover
                                placement="bottom-start"
                                width="300"
                                trigger="click"
                                v-model="tagPopoverVisible"
                            >
                                <el-tree
                                    ref="queryTagTreeRef"
                                    :data="tagTreeData"
                                    :props="{ label: 'name', children: 'children' }"
                                    show-checkbox
                                    node-key="id"
                                    :default-checked-keys="query.tagIds"
                                    @check-change="handleQueryTagTreeCheckChange"
                                    style="max-height: 200px; overflow-y: auto;"
                                    :check-strictly="true"
                                ></el-tree>
                                <div style="text-align: right; margin-top: 10px;">
                                    <el-button size="mini" type="primary" @click="confirmQueryTag">确认</el-button>
                                    <el-button size="mini" @click="tagPopoverVisible = false">取消</el-button>
                                </div>
                                <el-button
                                    slot="reference"
                                    type="text"
                                    style="border: 1px solid #dcdfe6; width: 280px; text-align: left; padding: 0 10px; height: 36px; line-height: 36px;"
                                >
                                    <template v-if="query.tagIds.length > 0">
                                        <el-tag
                                            v-for="tagId in query.tagIds.slice(0, 2)"
                                            :key="tagId"
                                            size="mini"
                                            closable
                                            @close="removeQueryTag(tagId)"
                                            style="margin-right: 4px;"
                                        >
                                            {{ getTagNameById(tagId) }}
                                        </el-tag>
                                        <span v-if="query.tagIds.length > 2">+{{ query.tagIds.length - 2 }}个</span>
                                    </template>
                                    <template v-else>
                                        <span style="color: #909399;">请选择标签</span>
                                    </template>
                                </el-button>
                            </el-popover>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <el-button type="primary" @click="queryDiscoverDetails">查询</el-button>
                        <el-button class="margin-left-10" type="success" @click="openAddDialog()">新增</el-button>
                    </el-col>
                </el-row>
                <el-row type="flex" align="middle">
                    <el-col :span="5">
                        <span> 挂品热门问答：</span>
                        <el-input style="width: 300px" placeholder="id挂品" v-model="query.relId"></el-input>
                        <el-input style="width: 300px" placeholder="排序" v-model="query.rank"></el-input>
                    </el-col>
                    <el-col :span="6">
                        <el-button type="primary" @click="allDiscoverDetailsRmAdd">上到热门问答列表</el-button>
                        <el-button type="primary" @click="allDiscoverDetailsRmDel">下到热门答问列表</el-button>
                    </el-col>
                </el-row>
            </el-card>
        </div>

        <div>
            <el-table border :data="details">
                <el-table-column prop="id" label="id"></el-table-column>
                <el-table-column prop="title" label="标题"></el-table-column>
                <el-table-column prop="subTitle" label="副标题"></el-table-column>
                <el-table-column label="icon">
                    <template slot-scope="scope">
                        <template v-if="scope.row.icon">
                            <img :src="VUE_APP_CDN_URL + scope.row.icon" width="70px" height="100px" alt="图片">
                        </template>
                    </template>
                </el-table-column>

              <el-table-column label="headIcon">
                <template slot-scope="scope">
                  <template v-if="scope.row.headIcon">
                    <img :src="VUE_APP_CDN_URL + scope.row.headIcon" width="70px" height="100px" alt="图片">
                  </template>
                </template>
              </el-table-column>

                <el-table-column prop="jump" label="跳转链接"></el-table-column>
                <el-table-column prop="startDt" label="开始时间" :formatter="formatDate"></el-table-column>
                <el-table-column prop="endDt" label="结束时间" :formatter="formatDate"></el-table-column>
                <el-table-column label="是否生效" align="center">
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.isOpen"
                            :active-value="true"
                            :inactive-value="false"
                            active-text="开启"
                            inactive-text="关闭"
                            @change="handleStatusChange(scope.row)"
                            :disabled="scope.row.statusLoading"
                        ></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="跳转类型">
                    <template slot-scope="scope">
                        <span>{{ getZoneTypeName(scope.row.zoneJumpType) || '未设置' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="文章归属">
                    <template slot-scope="scope">
                        <span>{{ getMenstrualPrepStage(scope.row.menstrualPrepStage) || '未设置' }}</span>
                    </template>
                </el-table-column>

                <el-table-column label="关联标签" min-width="150">
                    <template slot-scope="scope">
                        <el-tag
                            v-for="tagItem in scope.row.tagList || []"
                            :key="tagItem.id"
                            size="mini"
                            type="info"
                            style="margin-right: 4px;"
                        >
                            {{ tagItem.name }}(层级:{{ tagItem.level }})
                        </el-tag>
                        <span v-if="!(scope.row.tagList && scope.row.tagList.length)">无</span>
                    </template>
                </el-table-column>

                <el-table-column prop="summary" label="精简简介"></el-table-column>
                <el-table-column label="内容顶部主图">
                    <template slot-scope="scope">
                        <template v-if="scope.row.contentIcon">
                            <img :src="VUE_APP_CDN_URL + scope.row.contentIcon" width="70px" height="100px" alt="图片">
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="createDt" label="创建时间" :formatter="formatDate"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button plain size="mini" type="success" @click="openEditDialog(scope.row)">
                            编辑
                        </el-button>
                        <br>
                        <el-button plain size="mini" type="danger" @click="remove(scope.row)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.page"
                :page-sizes="[20,50,100]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next"
                :total="page.totalElements">
            </el-pagination>
        </div>

        <el-dialog
            :title="editDialog.title"
            center
            :visible.sync="editDialog.show"
            width="65%"
            @open="handleDialogOpen"
        >
            <el-form :model="addForm" class="edit-form">

                <el-form-item label="副标题" :label-width="labelWidth">
                    <el-input type="text" v-model="addForm.subTitle" placeholder="请输入副标题"></el-input>
                </el-form-item>
              <el-form-item label="作者" :label-width="labelWidth">
                <el-input type="text" v-model="addForm.title" placeholder="请输入标题"></el-input>
              </el-form-item>

                <el-form-item label="关联标签" :label-width="labelWidth">
                    <div class="selected-tags-container" v-if="selectedTagIds.length > 0">
                        <el-tag
                            v-for="tagId in selectedTagIds"
                            :key="tagId"
                            closable
                            @close="removeSelectedTag(tagId)"
                            size="mini"
                            class="selected-tag"
                        >
                            {{ getTagNameById(tagId) }}(层级:{{ getTagLevelById(tagId) }})
                        </el-tag>
                    </div>
                    <el-tree
                        ref="tagTreeRef"
                        :data="tagTreeData"
                        :props="{ label: 'name', children: 'children' }"
                        show-checkbox
                        node-key="id"
                        :checked-keys="selectedTagIds"
                        @check-change="handleTagTreeCheckChange"
                        class="beautify-tree"
                        style="max-height: 300px; overflow-y: auto; border: 1px solid #e6e6e6; border-radius: 4px; padding: 10px;"
                        :check-strictly="true"
                    ></el-tree>
                    <div style="margin-top: 8px; color: #666; font-size: 12px;">
                        💡 勾选子标签会自动勾选父标签，勾选父标签不会勾选子标签
                    </div>
                </el-form-item>

                <el-form-item label="是否可用：" :label-width="labelWidth">
                    <el-switch
                        v-model="addForm.isOpen"
                        :active-value="true"
                        :inactive-value="false"
                        active-text="开启"
                        inactive-text="关闭"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                    >
                    </el-switch>
                </el-form-item>
<!--                <el-form-item label="跳转链接" :label-width="labelWidth">
                    <el-input type="text" v-model="addForm.jump" placeholder="请输入跳转链接"></el-input>
                </el-form-item>-->
                <el-form-item label="有效期:" :label-width="labelWidth">
                    <el-date-picker
                        v-model="addForm.startDt"
                        type="datetime"
                        placeholder="选择开始时间"
                        style="width: 45%; margin-right: 10px;"
                    >
                    </el-date-picker>
                    <span>至</span>
                    <el-date-picker
                        v-model="addForm.endDt"
                        type="datetime"
                        placeholder="选择结束时间"
                        style="width: 45%; margin-left: 10px;"
                    >
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="跳转类型" :label-width="labelWidth">
                    <el-select v-model="addForm.zoneJumpType" placeholder="请选择跳转类型">
                        <el-option v-for="t in zoneJumpTypeEnum" :key="t.code" :value="t.code" :label="t.name">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="模式" :label-width="labelWidth">
                    <el-select v-model="addForm.menstrualPrepStage" placeholder="请选择模式归属">
                        <el-option v-for="t in menstrualPrepStageEnum" :key="t.code" :value="t.code" :label="t.name">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="精简简介" :label-width="labelWidth">
                    <el-input
                        type="text"
                        v-model="addForm.summary"
                        placeholder="请输入精简简介"
                        maxlength="100"
                        show-word-limit
                    >
                    </el-input>
                </el-form-item>

                <el-form-item label="内容编辑" :label-width="labelWidth">
                    <div class="editor-container">
                        <toolbar
                            style="border-bottom: 1px solid #e6e6e6"
                            :editor="editor"
                            :default-config="toolbarConfig"
                            :mode="mode"
                        />
                        <editor
                            style="height: 500px; overflow-y: hidden;"
                            v-model="html"
                            :default-config="editorConfig"
                            :mode="mode"
                            @onCreated="onCreated"
                        />
                    </div>
                </el-form-item>

                <el-form-item label="上传时间:" :label-width="labelWidth">
                    <el-date-picker
                        v-model="addForm.answerTime"
                        type="date"
                        placeholder="选择上传时间"
                        value-format="yyyy-MM-dd"
                        style="width: 100%;"
                    >
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="icon:（作者头像）" :label-width="labelWidth">
                    <el-upload
                        :headers="headers"
                        class="avatar-uploader"
                        :action="uploadURL"
                        :show-file-list="false"
                        :on-success="handleIconSuccess"
                        :before-upload="beforeIconUpload"
                    >
                        <div class="upload-box">
                            <img v-if="addForm.icon" :src="VUE_APP_CDN_URL + addForm.icon" class="upload-img" alt="头像">
                            <div v-else class="upload-placeholder">
                                <i class="el-icon-plus"></i>
                                <span>点击上传头像</span>
                            </div>
                        </div>
                    </el-upload>
                </el-form-item>


              <el-form-item label="头部缩略图" :label-width="labelWidth">
                <el-upload
                    :headers="headers"
                    class="avatar-uploader"
                    :action="uploadURL"
                    :show-file-list="false"
                    :on-success="hadleHeadIconSuccess"
                    :before-upload="beforeIconUpload"
                >
                  <div class="upload-box">
                    <img v-if="addForm.headIcon" :src="VUE_APP_CDN_URL + addForm.headIcon" class="upload-img" alt="头像">
                    <div v-else class="upload-placeholder">
                      <i class="el-icon-plus"></i>
                      <span>点击上传头像</span>
                    </div>
                  </div>
                </el-upload>
              </el-form-item>

<!--                <el-form-item label="内容顶部主图:" :label-width="labelWidth">
                    <el-upload
                        :headers="headers"
                        class="avatar-uploader"
                        :action="uploadURL"
                        :show-file-list="false"
                        :on-success="handleContentIconSuccess"
                        :before-upload="beforeContentIconUpload"
                    >
                        <div class="upload-box upload-box-large">
                            <img v-if="addForm.contentIcon" :src="VUE_APP_CDN_URL + addForm.contentIcon" class="upload-img" alt="主图">
                            <div v-else class="upload-placeholder">
                                <i class="el-icon-plus"></i>
                                <span>点击上传内容顶部主图</span>
                            </div>
                        </div>
                    </el-upload>
                </el-form-item>-->

            </el-form>

            <div class="dialog-footer">
                <div style="float: right;">
                    <el-button type="default" @click="closeEditDialog()">取 消</el-button>
<!--
                    <el-button type="success" @click="saveOrUpdateVideo(1)" style="margin-left: 10px;">确定(html文本)</el-button>
-->
                    <el-button type="primary" @click="saveOrUpdateVideo(2)" style="margin-left: 10px;">确定(纯文本)</el-button>
                </div>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import { formatDate } from "@/http/api";
import {
    allDiscoverDetails,
    allDiscoverDetailsRmAdd,
    allDiscoverDetailsRmDel,
    allDiscoversEnums,
    deleteDiscoverDetail,
    saveDiscoverDetail,
    getTagTreeWithoutHide
} from "@/http/womensApi";
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'

export default {
    inject: ['reload'],
    name: "ReMenDiscoverDetail",
    components: {
        Editor,
        Toolbar
    },
    data() {
        return {
            editor: null,
            html: '',
            toolbarConfig: {},
            editorConfig: { MENU_CONF: {} },
            mode: 'default',
            editDialog: {
                show: false,
                title: null
            },
            labelWidth: '120px',
            VUE_APP_BASE_URL: null,
            VUE_APP_CDN_URL: null,
            uploadURL: process.env.VUE_APP_BASE_URL + "game/upload",
            zoneJumpTypeEnum: null,
            menstrualPrepStageEnum: null,
            tagTreeData: [],
            tagPopoverVisible: false,
            selectedTagIds: [],
            addForm: {
                id: null,
                title: null,
                subTitle: null,
                icon: null,
                headIcon: null,
                jump: null,
                startDt: null,
                endDt: null,
                isOpen: true,
                zoneJumpType: null,
                menstrualPrepStage: null,
                summary: null,
                contentBody: null,
                contentIcon: null,
                answerTime: null,
                tagIds: [],
                tagList: [] // 移除tagLevels，直接从tagList取层级
            },
            details: null,
            page: {
                size: 20,
                page: 1,
                totalElements: null
            },
            query: {
                title: "",
                relId: "",
                rank: "",
                tagPaths: [],
                tagIds: [],
                size: null,
                page: null
            },
            headers: {},
        }
    },
    methods: {
        openAddDialog() {
            this.editDialog.title = '新增素材';
            this.editDialog.show = true;
            this.resetFormData();
        },
        openEditDialog(row) {
            this.editDialog.title = '编辑素材';
            this.editDialog.show = true;
            this.resetFormData();
            this.addForm = { ...this.addForm, ...row };
            this.html = row.contentBody || '';

            // 修复：从labelRelList准确获取标签和层级
            const tagList = row.tagList || (row.labelRelList ? row.labelRelList.map(rel => ({
                id: rel.labelId,
                name: this.getTagNameById(rel.labelId),
                level: rel.labelLevel || this.getTagLevelById(rel.labelId) // 优先用数据库存储的层级，兜底用树结构获取
            })) : []);

            this.addForm.tagList = tagList;
            this.addForm.tagIds = tagList.map(t => t.id);
            this.selectedTagIds = [...this.addForm.tagIds];

            this.$nextTick(() => {
                if (this.$refs.tagTreeRef) {
                    this.$refs.tagTreeRef.setCheckedKeys(this.selectedTagIds);
                }
            });
        },
        closeEditDialog() {
            this.editDialog.show = false;
            this.resetFormData();
        },
        resetFormData() {
            this.selectedTagIds = [];
            this.addForm = {
                id: null,
                title: null,
                subTitle: null,
                icon: null,
              headIcon:null,
                jump: null,
                startDt: null,
                endDt: null,
                isOpen: true,
                zoneJumpType: null,
                menstrualPrepStage: null,
                summary: null,
                contentBody: null,
                contentIcon: null,
                answerTime: null,
                tagIds: [],
                tagList: []
            };
            this.html = '';

            this.$nextTick(() => {
                if (this.$refs.tagTreeRef) {
                    this.$refs.tagTreeRef.setCheckedKeys([]);
                }
            });
        },
        handleQueryTagTreeCheckChange(node, checked) {
        },
        confirmQueryTag() {
            if (this.$refs.queryTagTreeRef) {
                this.query.tagIds = [...this.$refs.queryTagTreeRef.getCheckedKeys()];
                this.tagPopoverVisible = false;
                this.queryDiscoverDetails();
            }
        },
        removeQueryTag(tagId) {
            this.query.tagIds = this.query.tagIds.filter(id => id !== tagId);
            if (this.$refs.queryTagTreeRef) {
                this.$refs.queryTagTreeRef.setCheckedKeys(this.query.tagIds);
            }
            this.queryDiscoverDetails();
        },

        // 修复：确保标签名称获取准确
        getTagNameById(tagId) {
            // 1. 先从当前选中的 tagList 里拿（最准、最快）
            if (this.addForm.tagList && this.addForm.tagList.length) {
                const find = this.addForm.tagList.find(t => t.id === tagId)
                if (find) return find.name
            }

            // 2. 再从树里递归找（兼容所有场景）
            const findInTree = (nodes, targetId) => {
                for (const node of nodes) {
                    if (node.id === targetId) return node.name
                    if (node.children && node.children.length) {
                        const res = findInTree(node.children, targetId)
                        if (res) return res
                    }
                }
                return null
            }

            const name = findInTree(this.tagTreeData, tagId)
            return name || `标签:${tagId}`
        },

        // 核心修复：递归获取标签层级（准确匹配树结构）
        getTagLevelById(tagId) {
            // 定义递归函数，记录当前层级
            const findLevelRecursive = (nodes, targetId, currentLevel) => {
                for (const node of nodes) {
                    // 找到目标节点，返回当前层级
                    if (node.id === targetId) {
                        return currentLevel;
                    }
                    // 有子节点则递归查找，层级+1
                    if (node.children && node.children.length > 0) {
                        const level = findLevelRecursive(node.children, targetId, currentLevel + 1);
                        if (level) {
                            return level;
                        }
                    }
                }
                // 未找到返回1（默认层级）
                return null;
            };

            // 从根节点开始查找，初始层级为1
            const level = findLevelRecursive(this.tagTreeData, tagId, 1);
            return level || 1;
        },

        getParentIds(nodeId, tree = this.tagTreeData, parentIds = []) {
            for (const node of tree) {
                if (node.id === nodeId) {
                    return parentIds;
                }
                if (node.children && node.children.length) {
                    const result = this.getParentIds(nodeId, node.children, [...parentIds, node.id]);
                    if (result.length > 0) {
                        return result;
                    }
                }
            }
            return [];
        },

        // 修复：勾选标签时准确维护tagList（包含正确层级）
        handleTagTreeCheckChange(node, checked, indeterminate) {
            const tree = this.$refs.tagTreeRef;
            if (!tree) return;

            const currentNodeId = node.id;
            const parentIds = this.getParentIds(currentNodeId);

            if (checked) {
                const newCheckedKeys = [...new Set([...this.selectedTagIds, currentNodeId, ...parentIds])];
                this.selectedTagIds = newCheckedKeys;
            } else {
                this.selectedTagIds = this.selectedTagIds.filter(id => id !== currentNodeId);
            }

            tree.setCheckedKeys(this.selectedTagIds);

            // 核心修复：直接构建包含层级的tagList，避免索引错位
            this.addForm.tagList = this.selectedTagIds.map(tagId => ({
                id: tagId,
                name: this.getTagNameById(tagId),
                level: this.getTagLevelById(tagId) // 每个标签单独获取层级，确保准确
            }));
            this.addForm.tagIds = [...this.selectedTagIds];
        },

        // 修复：移除标签时同步更新tagList
        removeSelectedTag(tagId) {
            this.selectedTagIds = this.selectedTagIds.filter(id => id !== tagId);
            if (this.$refs.tagTreeRef) {
                this.$refs.tagTreeRef.setCheckedKeys(this.selectedTagIds);
            }
            this.addForm.tagIds = [...this.selectedTagIds];
            // 重新构建tagList，确保层级准确
            this.addForm.tagList = this.selectedTagIds.map(id => ({
                id,
                name: this.getTagNameById(id),
                level: this.getTagLevelById(id)
            }));
        },

        handleDialogOpen() {
        },
        onCreated(editor) {
            this.editor = Object.seal(editor)
        },
        formatDate(row, column) {
            return row[column.prop] ? formatDate(new Date(row[column.prop]), 'yyyy-MM-dd HH:mm:ss') : '无';
        },
        async loadTagTree() {
            try {
                const resp = await getTagTreeWithoutHide();
                const realData = resp.data || resp;
                if (realData && realData.status === 0 && Array.isArray(realData.info)) {
                    this.tagTreeData = realData.info;
                }
            } catch (err) {
                console.error("加载标签失败", err);
            }
        },
        queryDiscoverDetails() {
            this.query.page = this.page.page - 1;
            this.query.size = this.page.size;
            const queryParams = { ...this.query, tagIds: [...this.query.tagIds] };
            allDiscoverDetails(queryParams).then(resp => {
                this.details = resp.data.info.list.map(item => ({
                    ...item,
                    statusLoading: false,
                    tagList: item.tagList || (item.labelRelList ? item.labelRelList.map(rel => ({
                        id: rel.labelId,
                        name: this.getTagNameById(rel.labelId),
                        level: rel.labelLevel || this.getTagLevelById(rel.labelId)
                    })) : [])
                }));
                this.page.totalElements = resp.data.info.total;
                this.headers = { Authorization: this.$store.state.user.token };
            }).catch(err => {
                this.$message.error("查询素材失败：" + err.message);
            });
        },
        handleStatusChange(row) {
            row.statusLoading = true;
            const submitData = {
                ...row,
                isOpen: row.isOpen,
                tagList: row.tagList || [],
                labelRelList: row.tagList?.map(tag => ({
                    labelId: tag.id,
                    discoverId: row.id,
                    labelLevel: tag.level || 1 // 直接用tagList里的层级
                })) || []
            };
            saveDiscoverDetail(submitData).then(resp => {
                row.statusLoading = false;
                if (resp.data.status === 0) {
                    this.$message.success(row.isOpen ? '已开启' : '已关闭');
                } else {
                    row.isOpen = !row.isOpen;
                    this.$message.error("修改状态失败：" + (resp.data.msg || "接口异常"));
                }
            }).catch(err => {
                row.statusLoading = false;
                row.isOpen = !row.isOpen;
                this.$message.error("修改状态失败：" + err.message);
            });
        },

        // 核心修复：保存时准确传递labelLevel
        saveOrUpdateVideo(type) {
            // 重新同步tagList（确保层级最新）
            this.addForm.tagList = this.selectedTagIds.map(tagId => ({
                id: tagId,
                name: this.getTagNameById(tagId),
                level: this.getTagLevelById(tagId)
            }));
            this.addForm.tagIds = [...this.selectedTagIds];

            if (this.addForm.tagIds.length === 0) {
                this.$message.warning("请选择至少一个标签！");
                return;
            }

            if (type === 1) {
                this.addForm.contentBody = this.html;
            } else if (type === 2 && this.editor) {
                this.addForm.contentBody = this.editor.getText();
            }

            // 修复：从tagList中取层级，而非索引匹配
            const submitData = {
                ...this.addForm,
                labelRelList: this.addForm.tagList.map(tag => ({ // 直接遍历tagList
                    labelId: tag.id,
                    discoverId: this.addForm.id || null,
                    labelLevel: tag.level || 1 // 直接用tag里的层级，100%准确
                }))
            };

            saveDiscoverDetail(submitData).then(resp => {
                if (resp.data.status === 0) {
                    this.closeEditDialog();
                    this.queryDiscoverDetails();
                    this.$message.success("保存成功！");
                } else {
                    this.$message.error("保存失败：" + (resp.data.msg || "接口异常"));
                }
            }).catch(err => {
                this.$message.error("保存失败：" + err.message);
            });
        },

        remove(data) {
            this.$confirm('此操作将永久删除该素材, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteDiscoverDetail(data).then(resp => {
                    if (resp.data.status === 0) {
                        this.queryDiscoverDetails();
                        this.$message.success("删除成功");
                    } else {
                        this.$message.error("删除失败：" + (resp.data.msg || "接口异常"));
                    }
                }).catch(err => {
                    this.$message.error("删除失败：" + err.message);
                });
            }).catch(() => {
                this.$message.info("已取消删除");
            });
        },
        handleIconSuccess(data) {
            this.addForm.icon = data.info;
        },
        hadleHeadIconSuccess(data) {
            this.addForm.headIcon = data.info;
        },
        handleContentIconSuccess(data) {
            this.addForm.contentIcon = data.info;
        },
        beforeIconUpload(data) {
            const suffix = data.name.substring(data.name.lastIndexOf('.')).toLowerCase();
            const type = ['.png', '.jpg', '.jpeg'].includes(suffix);
            if (!type) {
                this.$message.error('上传图片只能是png/jpg格式!');
            }
            return type;
        },
        beforeContentIconUpload(data) {
            const suffix = data.name.substring(data.name.lastIndexOf('.')).toLowerCase();
            const type = ['.png', '.jpg', '.jpeg'].includes(suffix);
            if (!type) {
                this.$message.error('上传图片只能是png/jpg格式!');
            }
            return type;
        },
        editDialogFun(show, title, data) {
            if (show) {
                if (data) {
                    this.openEditDialog(data);
                } else {
                    this.openAddDialog();
                }
            } else {
                this.closeEditDialog();
            }
        },
        handleSizeChange(size) {
            this.page.size = size;
            this.queryDiscoverDetails();
        },
        handleCurrentChange(page) {
            this.page.page = page;
            this.queryDiscoverDetails();
        },
        getZoneTypeName(code) {
            const item = this.zoneJumpTypeEnum?.find(i => i.code === code);
            return item ? item.name : '未设置';
        },
        getMenstrualPrepStage(code) {
            const item = this.menstrualPrepStageEnum?.find(i => i.code === code);
            return item ? item.name : '未设置';
        },
        allDiscoverDetailsRmAdd() {
            allDiscoverDetailsRmAdd(this.query).then(resp => {
                if (resp.data.status === 0) {
                    this.$message.success("上到文章列表成功");
                    this.queryDiscoverDetails();
                } else {
                    this.$message.error("操作失败：" + (resp.data.msg || "接口异常"));
                }
            }).catch(err => {
                this.$message.error("操作失败：" + err.message);
            });
        },
        allDiscoverDetailsRmDel() {
            allDiscoverDetailsRmDel(this.query).then(resp => {
                if (resp.data.status === 0) {
                    this.$message.success("下到文章列表成功");
                    this.queryDiscoverDetails();
                } else {
                    this.$message.error("操作失败：" + (resp.data.msg || "接口异常"));
                }
            }).catch(err => {
                this.$message.error("操作失败：" + err.message);
            });
        }
    },
    beforeDestroy() {
        if (this.editor) this.editor.destroy()
    },
    async created() {
        this.editorConfig.MENU_CONF['uploadImage'] = {
            server: process.env.VUE_APP_WOMENS_ADMIN_URL + '/discover/upload',
            headers: { Authorization: this.$store.state.user.token }
        };
        await this.loadTagTree();
        this.queryDiscoverDetails();
        allDiscoversEnums().then(resp => {
            this.zoneJumpTypeEnum = resp.data.info.zoneJumpTypeEnum;
            this.menstrualPrepStageEnum = resp.data.info.menstrualPrepStageEnum;
        }).catch(err => {
            this.$message.error("加载枚举失败：" + err.message);
        });
    },
    mounted() {
        this.VUE_APP_BASE_URL = process.env.VUE_APP_BASE_URL;
        this.VUE_APP_CDN_URL = process.env.VUE_APP_CDN_URL;
        this.headers = { Authorization: this.$store.state.user.token };
    }
}
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="less" scoped>
.form-container {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.edit-form {
    padding: 10px 0;
}

.beautify-tree {
    .el-tree-node {
        padding: 4px 0;

        &:hover {
            background-color: #f8f9fa;
        }

        .el-tree-node__content {
            height: 32px;
            border-radius: 4px;
            padding-left: 8px;

            &:hover {
                background-color: #e8f4ff;
            }
        }
    }

    .el-tree-node__label {
        font-size: 14px;
        color: #333;
    }
}

.selected-tags-container {
    margin-bottom: 10px;
    min-height: 32px;
}

.selected-tag {
    margin-right: 8px !important;
    margin-bottom: 8px !important;
    background-color: #e8f4ff;
    border-color: #d1eaff;
    color: #1989fa;

    &:hover {
        background-color: #d1eaff;
    }
}

.avatar-uploader {
    .upload-box {
        width: 120px;
        height: 120px;
        border: 1px dashed #dcdfe6;
        border-radius: 8px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        transition: all 0.3s;

        &:hover {
            border-color: #409eff;
            background-color: #f8f9fa;
        }

        &.upload-box-large {
            width: 200px;
            height: 150px;
        }

        .upload-img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 8px;
        }

        .upload-placeholder {
            display: flex;
            flex-direction: column;
            align-items: center;
            color: #909399;

            i {
                font-size: 24px;
                margin-bottom: 5px;
            }

            span {
                font-size: 12px;
            }
        }
    }
}

.editor-container {
    border: 1px solid #e6e6e6;
    border-radius: 8px;
    overflow: hidden;

    :deep(.w-e-toolbar) {
        background-color: #f8f9fa;
        border-bottom: 1px solid #e6e6e6;
    }

    :deep(.w-e-text-container) {
        background-color: #fff;
    }
}

.dialog-footer {
    padding: 10px 0;
    border-top: 1px solid #e6e6e6;
    margin-top: 10px;

    .el-button {
        padding: 8px 16px;
        border-radius: 6px;
    }
}

.tree-select-wrapper {
    :deep(.el-popover) {
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

    :deep(.el-button--text) {
        white-space: normal;
        word-break: break-all;

        &:hover {
            border-color: #409eff;
            color: #409eff;
        }
    }
}

.margin-left-10 {
    margin-left: 10px;
}

:deep(.el-table) {
    --el-table-header-text-color: #666;
    --el-table-row-hover-bg-color: #f8f9fa;
}

:deep(.el-pagination) {
    margin-top: 20px;
    text-align: right;

    .el-pagination__total {
        margin-right: 10px;
    }
}
</style>